import { render, staticRenderFns } from "./Figures.vue?vue&type=template&id=115d63d4"
import script from "./Figures.vue?vue&type=script&lang=js"
export * from "./Figures.vue?vue&type=script&lang=js"
import style0 from "./Figures.vue?vue&type=style&index=0&id=115d63d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports